<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header-blue-bg">
          <div class="title-with-icon">
            <div class="title-with-icon__icon title-with-icon__icon-white title-with-icon__icon_exclamation"></div>
            <div class="title-with-icon__title">Олимпиада «Кадры для экспорта»</div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-if="loading" class="content_22">Проверяем регистрацию на олимпиаду</p>
          <template v-else-if="status === 'not_authenticated'">
            <p class="content_22 mb-4">Войдите в аккаунт, с которым вы регистрировались на олимпиаду</p>
            <div><button type="button" class="link-target" @click="hideThen(() => $emit('login'))"><span>Войти</span></button></div>
          </template>
          <template v-else-if="status === 'not_registered'">
            <p class="content_22 mb-4">Вы не зарегистрированы на олимпиаду 2026 года.</p>
            <div v-if="registrationOpen"><button type="button" class="link-target" @click="hideThen(() => $emit('register'))"><span>Зарегистрироваться</span></button></div>
            <p v-else class="content_22 content_700">Регистрация завершена</p>
          </template>
          <template v-else-if="status">
            <p v-if="trackTitle" class="content_22 content_700 content_red mb-3">{{ trackTitle }}</p>
            <p v-if="status === 'no_test' || status === 'before_start'" class="content_22">
              Олимпиада начнется {{ startText }} по Москве. Возвращайтесь на эту страницу в день старта.
            </p>
            <template v-else-if="status === 'open' || status === 'in_progress'">
              <p v-for="(paragraph, index) in descriptionParagraphs" :key="index" class="content_18 mb-2">{{ paragraph }}</p>
              <test-start-info class="mt-4" :test="testInfo" />
              <div class="notice notice_red mt-4 mb-4">
                <div class="notice__content">
                  <p>Задания можно пройти один раз. После старта время идет, даже если закрыть страницу</p>
                </div>
              </div>
              <div>
                <button type="button" class="link-target" @click="begin">
                  <span>{{ status === 'open' ? 'Начать олимпиаду' : 'Продолжить' }}</span>
                </button>
              </div>
            </template>
            <p v-else-if="status === 'finished'" class="content_22">Вы прошли задания олимпиады. Итоги объявим в ноябре.</p>
            <p v-else-if="status === 'closed'" class="content_22">Прием ответов завершился {{ endText }} по Москве.</p>
            <p v-else class="content_22">Не удалось проверить регистрацию. Обновите страницу.</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import TestStartInfo from "@/components/profile/test/TestStartInfo.vue";
window.jQuery = $

const TRACK_TITLES = {
  junior: 'Трек «Старт»',
  pro: 'Трек «Профи»'
}

export default {
  name: 'OlympicsStartModal',
  components: {TestStartInfo},
  props: {
    id: {
      type: String,
      default: 'olympics-start-modal'
    },
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    // Состояние участника из GET olympiad/start или {status: 'not_authenticated'}
    state: {
      type: Object,
      default: null
    },
    registrationOpen: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    $('#' + this.id).on('hide.bs.modal', () => {
      this.$emit('input', false)
    })
  },
  watch: {
    value(val) {
      $('#' + this.id).modal(val ? 'show' : 'hide')
    }
  },
  computed: {
    status() {
      return this.state ? this.state.status : null
    },
    trackTitle() {
      return this.state && TRACK_TITLES[this.state.track] ? TRACK_TITLES[this.state.track] : ''
    },
    startText() {
      return this.formatDate(this.state.startAt)
    },
    endText() {
      return this.formatDate(this.state.endAt)
    },
    // Вводный текст задания трека - описание теста в админке
    descriptionParagraphs() {
      const description = this.state.test && this.state.test.description ? this.state.test.description : ''
      return description.split(/\n+/).map(paragraph => paragraph.trim()).filter(paragraph => paragraph)
    },
    testInfo() {
      return {
        duration: this.state.test.duration,
        questionsCount: this.state.test.questionsCount,
        retakes: 0,
        pass_percent: null
      }
    }
  },
  methods: {
    formatDate(value) {
      const date = new Date(value)
      const day = date.toLocaleDateString('ru-RU', {day: 'numeric', month: 'long', timeZone: 'Europe/Moscow'})
      const time = date.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow'})
      return `${day} в ${time}`
    },
    // Переход и следующее окно - после закрытия этого, иначе на странице остается затемнение
    hideThen(callback) {
      $('#' + this.id).one('hidden.bs.modal', callback).modal('hide')
    },
    begin() {
      const testUrl = '/lk/test/' + this.state.test.id + (this.status === 'open' ? '?start=true' : '')
      this.hideThen(() => this.$router.push(testUrl).catch(() => {}))
    }
  }
}
</script>
